import React, { useEffect, useState } from "react";

const RadioButton = ({ options, onChange, defaultChecked }) => {
	const [selectedOption, setSelectedOption] = useState(defaultChecked);

	const handleRadioChangeData = (event) => {
		const value = event.target.value;
		const label = event.target.nextSibling.textContent;
		setSelectedOption(value);
		onChange(value, label);
	};

	return (
		<div className="flex radio-button-group justify-content-between mt-3 mb-3">
			{options.map((option, index) => (
				<div className="d-flex align-items-center" key={index}>
					<input //
						type="radio"
						id={option.id}
						name="radio-group"
						value={option.value}
						checked={selectedOption === option.value}
						onChange={handleRadioChangeData}
						style={{ marginRight: "8px" }}
					/>

					<label htmlFor={option.id}>{option.label}</label>
				</div>
			))}
		</div>
	);
};

export default RadioButton;
